/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type ConsumptionType = typeof ConsumptionType[keyof typeof ConsumptionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsumptionType = {
  Generate: 'Generate',
  Consume: 'Consume',
  Other: 'Other',
  Sjv: 'Sjv',
} as const;
